import axios from "axios";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("banner.service");

const axiosInstance = axios.create({
    baseURL: "https://www.easybanner.pl",
    headers: {
        "x-api-key": "8593b801351a4f51b6bfd748180076b3", // TODO: move to Back-end!!!
        "Content-Type": "application/json;charset=utf-8",
    },
});

axiosInstance.interceptors.response.use(
    (res) => res?.data || res,
    (errorData) => {
        const { response } = errorData;
        if (response) {
            const {
                data: { error },
            } = response;
            return Promise.reject(error);
        }
        return Promise.reject("UNKNOWN_ERROR");
    }
);

export const legacyBannerService = {
    makeCreation(data) {
        logger.trace("Sending HTML to banner", data.html);
        return axiosInstance.post("/creations", data).catch(handleErrorByMessage());
    },
};
